var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourceGroup2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/Azure/Resource Group@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.9762325%",
    y1: "7.4114724%",
    x2: "37.1841038%",
    y2: "103.76182%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0669BC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.7237125%",
    y1: "52.3127289%",
    x2: "52.6927812%",
    y2: "54.8636556%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.3,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.2,
    offset: "7.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.1,
    offset: "32.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.05,
    offset: "62.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.2725685%",
    y1: "4.60005789%",
    x2: "62.4796378%",
    y2: "99.9794963%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2892DF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/Azure/Resource-Group",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F1F4FB",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7, 9)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9999,7.06543394 C9.9597004,7.06543394 9.9597004,7.06543394 9.9195008,7.02583326 L4.01615984,3.66617546 C3.97596024,3.62657478 3.93576064,3.5871741 3.93576064,3.50797274 C3.93576064,3.42877137 3.97596024,3.3893707 4.01615984,3.34997002 L9.8795012,0.0295128895 C9.92580302,-0.00983762985 9.99379778,-0.00983762985 10.0400996,0.0295128895 L15.9436406,3.3893707 C15.9838402,3.42897138 16.0240398,3.46837206 16.0240398,3.54757342 C16.0240398,3.62677478 15.9838402,3.66617546 15.9436406,3.70557614 L10.0802992,7.02583326 C10.0802992,7.06543394 10.0400996,7.06543394 9.9999,7.06543394 M16.1844382,0.0295128895 C16.2650373,0.0295128895 16.3854361,0.0691135709 16.4658353,0.108514249 L19.196808,1.68954145 C19.6788032,1.96614621 20,2.51955573 20,3.03356457 L20,12.994536 C20,13.5083448 19.6788032,14.101355 19.196808,14.3383591 L16.4658353,15.9193863 C16.1846382,16.077589 15.8232418,15.9983876 15.6626434,15.7217829 C15.502045,15.4451781 15.5822442,15.089372 15.8634414,14.9311693 L18.5942141,13.3501421 C18.6746133,13.3105414 18.795012,13.112938 18.795012,12.994336 L18.795012,3.03356457 C18.795012,2.91496253 18.6746133,2.71735913 18.5942141,2.67775845 L15.8632414,1.09673125 C15.5820442,0.938728533 15.501845,0.582922411 15.6624434,0.306117649 C15.7828422,0.14811493 15.9836402,0.0295128895 16.1844382,0.0295128895 Z M4.33735663,0.306317652 C4.49795502,0.582922411 4.41775582,0.938728533 4.13655863,1.09693125 L1.40558594,2.67795846 C1.32518675,2.71755914 1.20478795,2.91516254 1.20478795,3.03376458 L1.20478795,12.994736 C1.20478795,13.113338 1.32518675,13.3109414 1.40558594,13.3505421 L4.13655863,14.9315693 C4.41775582,15.089572 4.49795502,15.4453781 4.33735663,15.7221829 C4.17675823,15.8801856 4.01615984,15.9987876 3.81536185,15.9987876 C3.73476265,15.9987876 3.61436386,15.959187 3.53396466,15.9197863 L0.803191968,14.3385591 C0.321196788,14.0619543 0,13.5085448 0,12.994736 L0,3.03376458 C0,2.51995574 0.321196788,1.92694554 0.803191968,1.68974145 L3.53416466,0.108714252 C3.81536185,-0.0492884663 4.17675823,0.029712893 4.33735663,0.306317652 Z M3.33336667,4.81239518 L9.23690763,8.17225299 C9.27710723,8.21185367 9.31710683,8.25125435 9.31710683,8.33045571 L9.31710683,15.0501713 C9.31710683,15.1291727 9.27690723,15.1687734 9.23690763,15.208374 C9.23690763,15.2380746 9.21429536,15.2454997 9.18603001,15.247356 L9.15650843,15.2477747 C9.11630884,15.2477747 9.07610924,15.2477747 9.07610924,15.208174 L3.17276827,11.8483162 C3.13256867,11.8087156 3.09236908,11.7693149 3.09236908,11.6901135 L3.09236908,4.9705979 C3.09236908,4.89159654 3.13256867,4.85199586 3.17276827,4.81239518 C3.21907009,4.77304466 3.28706485,4.77304466 3.33336667,4.81239518 Z M16.8270317,4.89159654 C16.8672313,4.93119722 16.9074309,4.9705979 16.9074309,5.04979926 L16.9074309,11.7299142 C16.9074309,11.8089156 16.8672313,11.8485162 16.8270317,11.8879169 L10.9236908,15.2475747 L10.8432916,15.2475747 C10.803092,15.2475747 10.7628924,15.2475747 10.7628924,15.207974 C10.7226928,15.1683734 10.6826932,15.1289727 10.6826932,15.0497713 L10.6826932,8.40945707 C10.6826932,8.33045571 10.7228928,8.29085503 10.7628924,8.25145435 L16.6664333,4.89159654 C16.7127352,4.85224602 16.7807299,4.85224602 16.8270317,4.89159654 Z",
    id: "Shape",
    fill: "#658BD3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icons/18px/Amazon/Color",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.7427, 21.5386)",
    id: "azure"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.14851413,0.000107304529 L5.94320907,0.000107304529 L3.04204138,8.59380512 C2.98090095,8.77487422 2.81106292,8.89683312 2.61990699,8.89683312 L0.444943546,8.89683312 C0.301643642,8.89683312 0.167108917,8.82785723 0.0835239203,8.71148873 C-6.10768296e-05,8.59512022 -0.0224617556,8.44562453 0.0233458143,8.30987734 L2.72627241,0.303135295 C2.78738848,0.121986417 2.95729037,0 3.14851413,0 L3.14851413,0.000107304529 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20961224,5.76418457 L2.77789881,5.76418457 C2.69358223,5.76409147 2.61779822,5.8155943 2.58686426,5.8940118 C2.5559303,5.97242931 2.57614911,6.06178415 2.63783134,6.11925538 L5.48554799,8.77654474 C5.56845912,8.85386722 5.67762878,8.89683312 5.79101315,8.89683312 L8.30042123,8.89683312 L7.20961224,5.76418457 Z",
    id: "Path",
    fill: "#0078D4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14851413,0.00010402031 C2.95501254,-0.000635074497 2.78352507,0.124545964 2.72530643,0.309037044 L0.0266730877,8.30258063 C-0.0222326534,8.43886588 -0.0016364072,8.5904278 0.0818658777,8.7087287 C0.165368163,8.82702959 0.301298125,8.89722435 0.446124191,8.89683474 L2.67722196,8.89683474 C2.84639467,8.86661435 2.98621907,8.74773187 3.04322203,8.58564998 L3.58138166,7.00001095 L5.503687,8.79253311 C5.58424228,8.85914778 5.68529465,8.89598135 5.7898325,8.89683474 L8.28990276,8.89683474 L7.19340519,5.76418469 L3.99696883,5.76493582 L5.95329822,0.00010402031 L3.14851413,0.00010402031 Z",
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71803443,0.302706077 C6.65700464,0.121849003 6.48735631,0.000107304529 6.2964367,0.000107304529 L3.18178686,0.000107304529 C3.37269584,0.000107304529 3.54232688,0.121869652 3.60338459,0.302706077 L6.30641852,8.30977004 C6.35226066,8.44554204 6.32988048,8.59507767 6.24629549,8.71148872 C6.16271049,8.82789977 6.02815526,8.89694042 5.88482079,8.89694042 L8.99957796,8.89694042 C9.1428935,8.89694042 9.27741671,8.82785091 9.36097663,8.71144515 C9.44453654,8.5950394 9.46690445,8.44552411 9.42106836,8.30977004 L6.71803443,0.302706077 Z",
    id: "Path",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceGroup2X);
export default __webpack_public_path__ + "static/media/Resource Group@2x.58b6f5d02e30986f7e3dc06d231d5e88.svg";
export { ForwardRef as ReactComponent };